// extracted by mini-css-extract-plugin
module.exports = {"SearchPanel":"on_a bfq_cw bfq_jx bfq_jo bfq_a bfq_j bfq_rh bfq_ri","SearchPanel__icon":"on_b bfq_uh bfq_hb bfq_rn bfq_tt","SearchPanel__input":"on_c bfq_iv bfq_cx bfq_z"};